import { BadImplementationException, composeUrl } from '@nu-art/ts-common';
// noinspection TypeScriptPreferShortImport
import { BaseHttpModule_Class, BaseHttpRequest, HttpException } from '@nu-art/thunderstorm-shared';
// noinspection TypeScriptPreferShortImport
import { gzipSync } from 'zlib';
export class ModuleFE_XHR_Class extends BaseHttpModule_Class {
    init() {
        super.init();
        let origin = this.config.origin;
        if (!origin)
            throw new BadImplementationException('Did yo\ forget to set the origin config key for the HttpModule?');
        if (origin?.endsWith('/'))
            origin = origin.substring(0, origin.length - 1);
        this.origin = origin;
    }
    createRequest(apiDef, data) {
        const request = new XhrHttpRequest(apiDef.path, data, this.shouldCompress())
            .setLogger(this)
            .setMethod(apiDef.method)
            .setTimeout(this.timeout)
            .setOnCompleted(this.defaultOnComplete)
            .setOnError(this.defaultOnError)
            .addHeaders(this.getDefaultHeaders());
        if (apiDef.fullUrl)
            request.setUrl(apiDef.fullUrl);
        else
            request
                .setOrigin(apiDef.baseUrl ?? this.origin)
                .setRelativeUrl(apiDef.path);
        return request;
    }
}
export const ModuleFE_XHR = new ModuleFE_XHR_Class();
class XhrHttpRequest extends BaseHttpRequest {
    xhr;
    constructor(requestKey, requestData, shouldCompress) {
        super(requestKey, requestData);
        this.compress = shouldCompress === undefined ? true : shouldCompress;
    }
    getStatus() {
        const xhr = this.xhr;
        if (!xhr)
            throw new BadImplementationException('No xhr object!');
        return xhr.status;
    }
    getResponse() {
        const xhr = this.xhr;
        if (!xhr)
            throw new BadImplementationException('No xhr object!');
        return xhr.response;
    }
    abortImpl() {
        this.xhr?.abort();
    }
    getErrorResponse() {
        const rawResponse = this.getResponse();
        let response = undefined;
        if (rawResponse) {
            try {
                response = rawResponse && JSON.parse(rawResponse);
            }
            catch (e) {
                response = { debugMessage: rawResponse };
            }
        }
        return response;
    }
    prepareJsonBody(bodyObject) {
        return JSON.stringify(bodyObject);
    }
    // private buildXHR = () => {
    // 	const xhr = new XMLHttpRequest();
    // 	const fullUrl = composeUrl(this.url, this.params);
    // 	xhr.open(this.method, fullUrl);
    // 	xhr.timeout = this.timeout;
    // 	Object.keys(this.headers).forEach((key) => {
    // 		xhr.setRequestHeader(key, this.headers[key].join('; '));
    // 	});
    // 	return xhr;
    // };
    executeImpl() {
        //loop through whatever preprocessor
        return new Promise((resolve, reject) => {
            if (this.aborted)
                return resolve();
            const xhr = new XMLHttpRequest();
            // @ts-ignore
            // noinspection JSConstantReassignment
            this.xhr = xhr;
            this.xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4)
                    return;
                resolve();
            };
            this.xhr.onerror = (err) => {
                if (xhr.readyState === 4 && xhr.status === 0) {
                    reject(new HttpException(404, this.url));
                    return;
                }
                reject(err);
            };
            const fullUrl = composeUrl(this.url, this.params);
            this.xhr.ontimeout = (err) => {
                // console.log(`${this.url} - Request timeout`);
                reject(err);
            };
            this.xhr.onload = (err) => {
                // HttpModule.logVerbose("onload");
            };
            this.xhr.onloadstart = (err) => {
                // HttpModule.logVerbose("onloadstart");
            };
            this.xhr.onloadend = (err) => {
                // HttpModule.logVerbose("onloadend");
            };
            this.xhr.onabort = (err) => {
                // HttpModule.logVerbose("onabort");
            };
            // TODO: investigate which one should work
            this.xhr.onprogress = this.onProgressListener;
            this.xhr.upload.onprogress = this.onProgressListener;
            this.xhr.open(this.method, fullUrl);
            // console.log(`${this.url} - setting XHR timeout: ${this.timeout}`);
            this.xhr.timeout = this.timeout;
            Object.keys(this.headers).forEach((key) => {
                xhr.setRequestHeader(key, this.headers[key].join('; '));
            });
            let body = this.body;
            if (typeof body === 'string' && this.compress)
                try {
                    body = gzipSync(this.body);
                }
                catch (error) {
                    return reject(error);
                }
            return this.xhr.send(body);
        });
    }
    // stream() {
    // 	const readable = new Readable();
    // 	const xhr = this.buildXHR();
    // 	let lastPosition = 0;
    //
    // 	// @ts-ignore
    // 	// noinspection JSConstantReassignment
    // 	this.xhr = xhr;
    //
    // 	this.xhr.onreadystatechange = () => {
    // 		//If Loading
    // 		if (xhr.readyState === 3) {
    // 			const currentChunk = xhr.responseText.substring(lastPosition);
    // 			lastPosition = xhr.responseText.length;
    // 			readable.push(currentChunk);
    // 		} else if (xhr.readyState === 4) {
    // 			readable.push(null);
    // 		}
    // 	};
    //
    // 	let body: any = this.body;
    // 	if (typeof body === 'string' && this.compress)
    // 		try {
    // 			this.body = gzipSync(this.body);
    // 		} catch (error) {
    // 			throw error;
    // 		}
    //
    // 	this.xhr.send(body);
    // 	return readable;
    // }
    _getResponseHeader(headerKey) {
        if (!this.xhr)
            throw new BadImplementationException('No xhr object!');
        return this.xhr.getResponseHeader(headerKey) || undefined;
    }
}
//# sourceMappingURL=ModuleFE_XHR.js.map